import { render, staticRenderFns } from "./form-verification-email.vue?vue&type=template&id=0aacbf4e&"
import script from "./form-verification-email.vue?vue&type=script&lang=js&"
export * from "./form-verification-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports